import { render, staticRenderFns } from "./AddGuiji.vue?vue&type=template&id=744295ba&scoped=true&"
import script from "./AddGuiji.vue?vue&type=script&lang=js&"
export * from "./AddGuiji.vue?vue&type=script&lang=js&"
import style0 from "./AddGuiji.vue?vue&type=style&index=0&id=744295ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744295ba",
  null
  
)

export default component.exports